import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig";

// إرسال طلب تواصل باستخدام form-data
export const makeContactRequest = async (payload = {}) => {
  // payload: { name, email, message, phone, address, ...optional }
  try {
    const urlBase = (API_BASE_URL || "").replace(/\/$/, "");
    const apiPassword = API_PASSWORD || "";
    const endpoint = `${urlBase}/make/contact/request${apiPassword ? `?api_password=${encodeURIComponent(apiPassword)}` : ""}`;

    const formData = new FormData();
    Object.keys(payload || {}).forEach((key) => {
      const value = payload[key];
      if (value === undefined || value === null) return;
      // support arrays (multiple same keys)
      if (Array.isArray(value)) {
        value.forEach((v) => formData.append(key, v));
      } else {
        formData.append(key, value);
      }
    });

    const response = await axios.post(endpoint, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (err) {
    // رمي الخطأ كي يتم معالجته من قبل المستدعي
    throw err;
  }
};

// جلب جميع طلبات التواصل (يدعم معلمات استعلام اختيارية وتوكن)
export const getContactRequests = async (params = {}, token) => {
  try {
    const urlBase = (API_BASE_URL || "").replace(/\/$/, "");
    const apiPassword = API_PASSWORD || "";
    const queryObj = { ...params, api_password: apiPassword };
    const query = new URLSearchParams(queryObj).toString();
    const endpoint = `${urlBase}/get/all/contact/request${query ? `?${query}` : ""}`;

    const storedToken =
      token ||
      localStorage.getItem("token") ||
      localStorage.getItem("accessToken") ||
      localStorage.getItem("authToken") ||
      null;

    const headers = {
      ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
    };

    const response = await axios.get(endpoint, { headers });
    return response.data;
  } catch (err) {
    // رمي الخطأ كي يتم معالجته من قبل المستدعي
    throw err;
  }
};

// تعليم الطلب كمقروء (seen) للمسؤول عبر GET /make/contact/request/seen/{id}
export const markContactRequestSeen = async (id, token) => {
  if (!id) throw new Error("contact request id is required");

  try {
    const urlBase = (API_BASE_URL || "").replace(/\/$/, "");
    const apiPassword = API_PASSWORD || "";
    const query = apiPassword ? `?api_password=${encodeURIComponent(apiPassword)}` : "";
    const endpoint = `${urlBase}/make/contact/request/seen/${id}${query}`;

    const storedToken =
      token ||
      localStorage.getItem("token") ||
      localStorage.getItem("accessToken") ||
      localStorage.getItem("authToken") ||
      null;

    const headers = {
      ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
    };

    const response = await axios.get(endpoint, { headers });
    return response.data;
  } catch (err) {
    throw err;
  }
};

// حذف طلب تواصل حسب المعرف (مسار يستخدم GET كما في مثال الـ API)
export const deleteContactRequest = async (id, token) => {
  if (!id) throw new Error("contact request id is required for delete");

  try {
    const urlBase = (API_BASE_URL || "").replace(/\/$/, "");
    const apiPassword = API_PASSWORD || "";
    const query = apiPassword ? `?api_password=${encodeURIComponent(apiPassword)}` : "";
    const endpoint = `${urlBase}/delete/contact/request/${id}${query}`;

    const storedToken =
      token ||
      localStorage.getItem("token") ||
      localStorage.getItem("accessToken") ||
      localStorage.getItem("authToken") ||
      null;

    const headers = {
      ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
    };

    const response = await axios.get(endpoint, { headers });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export default {
  makeContactRequest,
  getContactRequests,
  markContactRequestSeen,
  deleteContactRequest,
};
